import {locale} from '../locale/AppLocale'
export const Currencies = () => {
    return {
        ils: {title: locale.get('currency_ils'), symbol: '₪'},
        usd: {title: locale.get('currency_usd'), symbol: '$'},
    };
};

